import React from 'react';
import PropTypes from 'prop-types';
import { ToolTipWrapper, ToolTipStyled, positions, types } from './ToolTipStyledComponents';
var supportedPositions = Object.keys(positions).reduce(function (carry, key) {
  carry.push(positions[key]);
  return carry;
}, []);
var supportedTypes = Object.keys(types).reduce(function (carry, key) {
  carry.push(types[key]);
  return carry;
}, []);

function ToolTip(_ref) {
  var children = _ref.children,
      tip = _ref.tip,
      position = _ref.position,
      type = _ref.type,
      show = _ref.show,
      hide = _ref.hide,
      wrapperStyle = _ref.wrapperStyle;
  var hoverEnabled = show === null && hide === null;
  var forceShowToolTip = !hoverEnabled && (show !== null && show || hide !== null && !hide);
  return React.createElement(ToolTipWrapper, {
    style: wrapperStyle
  }, children, React.createElement(ToolTipStyled, {
    position: position,
    type: type,
    hoverEnabled: hoverEnabled,
    forceShowToolTip: forceShowToolTip
  }, tip));
}

ToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  hide: PropTypes.bool,
  position: PropTypes.oneOf(supportedPositions),
  show: PropTypes.bool,
  tip: PropTypes.node.isRequired,
  type: PropTypes.oneOf(supportedTypes),
  // eslint-disable-next-line react/forbid-prop-types
  wrapperStyle: PropTypes.object
};
ToolTip.defaultProps = {
  hide: null,
  position: positions.top,
  show: null,
  type: types.default,
  wrapperStyle: null
};
export { positions, types };
export default ToolTip;